const Spinner = {
	variants: {
		custom_base: {
			color: "brand.100",
		},
	},
	defaultProps: {
		variant: "custom_base",
	},
};

export default Spinner;
